<div class="bg-white">
  <div class="flex flex-wrap items-center gap-2 sm:gap-3 lg:gap-5 mb-4">
    <!-- all firms -->
    <select class="bg-white border border-acb1c6 rounded-md px-1 2xl:px-2 py-2 text-[13px] text-383838 mb-2 sm:mb-0"
      [(ngModel)]="selectedFirmId" (change)="onFilterChange()">
      <option value="">All Firms</option>
      <option *ngFor="let item of firms" [value]="item.id">
        {{ item.name }}
      </option>
    </select>
    <!-- financial year -->
    <div class="flex items-center gap-1 mb-2 sm:mb-0">
      <p class="text-444 text-xs md:text-sm lg:text-[15px] font-semibold capitalize">Select Financial Year :</p>
      <div>
        <select class="bg-white border border-acb1c6 rounded-md px-1 2xl:px-2 py-2 text-[13px] text-383838"
          [(ngModel)]="selectedYear" (change)="onFilterChange()">
          <option value="" disabled hidden></option>
          <option *ngFor="let item of years" [value]="item">
            {{ item }}
          </option>
        </select>
      </div>
    </div>
    <!-- Account Balance -->
    <div class="flex items-center gap-1">
      <p class="text-444 text-xs md:text-sm lg:text-[15px] font-semibold capitalize">Account Balance :</p>
      <p class="text-444 text-xs md:text-sm lg:text-[15px] font-semibold capitalize flex items-center gap-1">
        <span class="text-0d5bab" *ngIf="selectedYear">01/04/{{selectedYear.split('-')[0]}}</span>To<span
          class="text-0d5bab" *ngIf="selectedYear">31/03/20{{selectedYear.split('-')[1]}}</span>
      </p>
    </div>
  </div>

  <div class="overflow-x-auto w-full mt-2 space-y-2">
    <table class="listtable1 border border-d9d9d9 bg-white w-full">
      <thead class="bg-f2ffe6 text-444 rounded-lg">
        <tr>
          <th class="text-center font-medium text-[13px] sm:text-sm lg:text-[15px] px-1.5 py-2 whitespace-nowrap">
            Sr No.
          </th>
          <th class="text-center font-medium text-[13px] sm:text-sm lg:text-[15px] px-1.5 py-2 whitespace-nowrap">
            Account Name
          </th>
          <th class="text-center font-medium text-[13px] sm:text-sm lg:text-[15px] px-1.5 py-2 whitespace-nowrap">
            Opening Balance
          </th>
          <th class="text-center font-medium text-[13px] sm:text-sm lg:text-[15px] px-1.5 py-2 whitespace-nowrap">
            Debit Amount (DR)
          </th>
          <th class="text-center font-medium text-[13px] sm:text-sm lg:text-[15px] px-1.5 py-2 whitespace-nowrap">
            Credit Amount (CR)
          </th>
          <th class="text-center font-medium text-[13px] sm:text-sm lg:text-[15px] px-1.5 py-2 whitespace-nowrap">
            Closing Balance
          </th>
          <th class="text-center font-medium text-[13px] sm:text-sm lg:text-[15px] px-1.5 py-2 whitespace-nowrap">
            Update
          </th>
          <th class="text-center font-medium text-[13px] sm:text-sm lg:text-[15px] px-1.5 py-2 whitespace-nowrap">
            Add
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let account of accountsData; let i = index">
          <!-- sr no -->
          <td class="text-center text-444 font-normal text-[13px] sm:text-sm lg:text-[15px] px-1.5 py-2">
            {{ i + 1 }}
          </td>
          <!-- Account Name -->
          <td
            class="text-left text-757575 font-normal text-[13px] sm:text-sm lg:text-[15px] px-1.5 py-2 whitespace-nowrap">
            {{ account.acc_user_acc }}
          </td>
          <!-- Opening Balance -->
          <td class="text-center text-757575 font-normal text-[13px] sm:text-sm lg:text-[15px] px-1.5 py-2">
            <div class="w-max lg:w-full flex items-center gap-2">
              <div class="relative grow">
                <input type="number" [(ngModel)]="account.opening_balance" placeholder="" (change)="calculateDiffs()"
                  class="block px-1 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none !bg-none focus:outline-none focus:ring-0 focus:border-c19725 peer" />
                <label
                  class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-left bg-white px-1 peer-focus:px-1 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Opening
                  Balance</label>
              </div>
              <!-- CR/DR -->
              <div class="w-20 relative">
                <select id="crdr-{{i}}" name="crdr-{{i}}" [(ngModel)]="account.opening_crdr" required
                  class="block px-1 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none !bg-none focus:outline-none focus:ring-0 focus:border-c19725 peer">
                  <option *ngFor="let type of crdrTypes" [value]="type">{{ type }}</option>
                </select>
                <label for="crdr-{{i}}"
                  class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-left bg-white px-1 peer-focus:px-1 peer-focus:text-c19725  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1 whitespace-nowrap">CR
                  / DR</label>
                <div class="absolute inset-y-0 right-2 flex items-center pointer-events-none">
                  <svg width="8" height="4" viewBox="0 0 6 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 0L2.85817 2.44986L5.71633 0H0Z" fill="#C19725" />
                  </svg>
                </div>
              </div>
            </div>
          </td>
          <!-- Debit Amount (DR) -->
          <td class="text-center text-757575 font-normal text-[13px] sm:text-sm lg:text-[15px] px-1.5 py-2">
            <div class="relative">
              <input type="number" [(ngModel)]="account.debit_amount" placeholder="" (change)="calculateDiffs()"
                class="block px-1 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none !bg-none focus:outline-none focus:ring-0 focus:border-c19725 peer" />
              <label
                class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-left bg-white px-1 peer-focus:px-1 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Debit
                Amount</label>
            </div>
          </td>
          <!--  Credit Amount (DR)  -->
          <td class="text-center text-757575 font-normal text-[13px] sm:text-sm lg:text-[15px] px-1.5 py-2">
            <div class="relative">
              <input type="number" [(ngModel)]="account.credit_amount" placeholder="" (change)="calculateDiffs()"
                class="block px-1 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none !bg-none focus:outline-none focus:ring-0 focus:border-c19725 peer" />
              <label
                class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-left bg-white px-1 peer-focus:px-1 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Credit
                Amount</label>
            </div>
          </td>
          <!--  Closing Balance  -->
          <td class="text-center text-757575 font-normal text-[13px] sm:text-sm lg:text-[15px] px-1.5 py-2">
            <div class="w-max lg:w-full flex items-center gap-2">
              <div class="relative grow">
                <input type="number" [(ngModel)]="account.closing_balance" placeholder="" (change)="calculateDiffs()"
                  class="block px-1 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none !bg-none focus:outline-none focus:ring-0 focus:border-c19725 peer" />
                <label
                  class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-left bg-white px-1 peer-focus:px-1 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Closing
                  Balance</label>
              </div>
              <!-- CR/DR -->
              <div class="w-20 relative">
                <select id="closing-crdr-{{i}}" name="closing-crdr-{{i}}" [(ngModel)]="account.closing_crdr" required
                  class="block px-1 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none !bg-none focus:outline-none focus:ring-0 focus:border-c19725 peer">
                  <option *ngFor="let type of crdrTypes" [value]="type">{{ type }}</option>
                </select>
                <label for="closing-crdr-{{i}}"
                  class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-left bg-white px-1 peer-focus:px-1 peer-focus:text-c19725  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1 whitespace-nowrap">CR
                  / DR</label>
                <div class="absolute inset-y-0 right-2 flex items-center pointer-events-none">
                  <svg width="8" height="4" viewBox="0 0 6 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 0L2.85817 2.44986L5.71633 0H0Z" fill="#C19725" />
                  </svg>
                </div>
              </div>
            </div>
          </td>

          <!-- Update -->
          <td class="text-center text-757575 font-normal text-[13px] sm:text-sm lg:text-[15px] px-1.5 py-2">
            <button (click)="onUpdateAccount(account)"
              class="cursor-pointer capitalize rounded-md border border-0d5bab bg-e9efff text-0d5bab text-[13px] lg:text-sm font-normal px-2 lg:px-4 py-1 text-center">Update</button>
          </td>
          <!-- Add -->
          <td class="text-center text-757575 font-normal text-[13px] sm:text-sm lg:text-[15px] px-1.5 py-2">
            <button *ngIf="shouldShowLoan(account.acc_user_acc)"
              class="whitespace-nowrap cursor-pointer capitalize rounded-md border border-bb0000 bg-fff6f6 text-bb0000 text-[13px] lg:text-sm font-normal px-2 lg:px-4 py-1 text-center">Add
              Loan</button>
            <button *ngIf="shouldShowStock(account.acc_user_acc)"
              class="whitespace-nowrap cursor-pointer capitalize rounded-md border border-0bb60b bg-f2ffe6 text-0bb60b text-[13px] lg:text-sm font-normal px-2 lg:px-4 py-1 text-center">Add
              Stock</button>
          </td>
        </tr>
        <!-- ✅ DIFF ROW -->
        <tr class="bg-white border-t border-d9d9d9">
          <td class="text-center text-red-600 font-semibold px-1.5 py-2"></td>
          <td class="text-left text-red-600 font-semibold px-1.5 py-2 whitespace-nowrap">
            Diff. in Balances
          </td>
          <td class="text-center text-red-600 font-semibold px-1.5 py-2">{{ totals.opening }}</td>
          <td class="text-center text-red-600 font-semibold px-1.5 py-2">{{ totals.debit }}</td>
          <td class="text-center text-red-600 font-semibold px-1.5 py-2">{{ totals.credit }}</td>
          <td class="text-center text-red-600 font-semibold px-1.5 py-2">{{ totals.closing }}</td>
          <td></td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>